import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { SessionProvider } from './session';
import { ConfirmProvider } from './components/ui';
// One entry point; index.css is the manifest that pulls in the design system
// and the transition layer in cascade order.
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('No #root element in index.html');

// The service worker (DM7, 2026-08-24; grown by round 42, 2026-09-30): a
// branded offline page, fast repeat opens, and the app page kept so Dayboard
// opens with no signal for offline form fill. It never touches /api/; see the
// header of public/sw.js. Production builds only — a worker in dev fights
// Vite's module serving and HMR. Registration failure is deliberately silent:
// the app works identically without it, just not with no signal.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        {/* Inside the router so a confirmation can be raised from any page, and
            outside App so one dialog serves the whole product rather than each
            page inventing its own "are you sure". */}
        <ConfirmProvider>
          <App />
        </ConfirmProvider>
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>
);
